import { render, staticRenderFns } from "./ForoCategoria.vue?vue&type=template&id=18c09cb8&scoped=true"
import script from "./ForoCategoria.vue?vue&type=script&lang=js"
export * from "./ForoCategoria.vue?vue&type=script&lang=js"
import style0 from "./ForoCategoria.vue?vue&type=style&index=0&id=18c09cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c09cb8",
  null
  
)

export default component.exports